// 20220302144625
// https://api.github.com/users/aydansamedova/repos?per_page=100

export default[
  {
    "id": 391182149,
    "node_id": "MDEwOlJlcG9zaXRvcnkzOTExODIxNDk=",
    "name": "aydansamedova",
    "full_name": "aydansamedova/aydansamedova",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/aydansamedova",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/aydansamedova",
    "forks_url": "https://api.github.com/repos/aydansamedova/aydansamedova/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/aydansamedova/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/aydansamedova/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/aydansamedova/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/aydansamedova/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/aydansamedova/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/aydansamedova/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/aydansamedova/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/aydansamedova/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/aydansamedova/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/aydansamedova/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/aydansamedova/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/aydansamedova/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/aydansamedova/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/aydansamedova/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/aydansamedova/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/aydansamedova/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/aydansamedova/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/aydansamedova/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/aydansamedova/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/aydansamedova/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/aydansamedova/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/aydansamedova/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/aydansamedova/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/aydansamedova/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/aydansamedova/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/aydansamedova/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/aydansamedova/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/aydansamedova/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/aydansamedova/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/aydansamedova/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/aydansamedova/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/aydansamedova/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/aydansamedova/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/aydansamedova/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/aydansamedova/deployments",
    "created_at": "2021-07-30T20:32:11Z",
    "updated_at": "2022-02-15T18:41:43Z",
    "pushed_at": "2022-02-15T18:42:46Z",
    "git_url": "git://github.com/aydansamedova/aydansamedova.git",
    "ssh_url": "git@github.com:aydansamedova/aydansamedova.git",
    "clone_url": "https://github.com/aydansamedova/aydansamedova.git",
    "svn_url": "https://github.com/aydansamedova/aydansamedova",
    "homepage": null,
    "size": 45,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 1,
    "open_issues": 1,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 391951629,
    "node_id": "MDEwOlJlcG9zaXRvcnkzOTE5NTE2Mjk=",
    "name": "aydansamedova.github.io",
    "full_name": "aydansamedova/aydansamedova.github.io",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/aydansamedova.github.io",
    "description": "Aydan Samedova - Portfolio Website",
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io",
    "forks_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/aydansamedova.github.io/deployments",
    "created_at": "2021-08-02T13:03:56Z",
    "updated_at": "2022-02-25T16:08:46Z",
    "pushed_at": "2022-02-25T12:05:54Z",
    "git_url": "git://github.com/aydansamedova/aydansamedova.github.io.git",
    "ssh_url": "git@github.com:aydansamedova/aydansamedova.github.io.git",
    "clone_url": "https://github.com/aydansamedova/aydansamedova.github.io.git",
    "svn_url": "https://github.com/aydansamedova/aydansamedova.github.io",
    "homepage": "https://aydansamedova.github.io/",
    "size": 4615,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      "frontend-developer"
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 404057435,
    "node_id": "MDEwOlJlcG9zaXRvcnk0MDQwNTc0MzU=",
    "name": "BasicReactProjects",
    "full_name": "aydansamedova/BasicReactProjects",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/BasicReactProjects",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/BasicReactProjects",
    "forks_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/BasicReactProjects/deployments",
    "created_at": "2021-09-07T16:59:26Z",
    "updated_at": "2022-01-03T15:40:29Z",
    "pushed_at": "2021-09-16T16:30:58Z",
    "git_url": "git://github.com/aydansamedova/BasicReactProjects.git",
    "ssh_url": "git@github.com:aydansamedova/BasicReactProjects.git",
    "clone_url": "https://github.com/aydansamedova/BasicReactProjects.git",
    "svn_url": "https://github.com/aydansamedova/BasicReactProjects",
    "homepage": null,
    "size": 711,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "CSS",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 354929240,
    "node_id": "MDEwOlJlcG9zaXRvcnkzNTQ5MjkyNDA=",
    "name": "Camellia_baku",
    "full_name": "aydansamedova/Camellia_baku",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/Camellia_baku",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/Camellia_baku",
    "forks_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/Camellia_baku/deployments",
    "created_at": "2021-04-05T18:17:06Z",
    "updated_at": "2021-07-24T14:00:39Z",
    "pushed_at": "2021-04-18T15:51:39Z",
    "git_url": "git://github.com/aydansamedova/Camellia_baku.git",
    "ssh_url": "git@github.com:aydansamedova/Camellia_baku.git",
    "clone_url": "https://github.com/aydansamedova/Camellia_baku.git",
    "svn_url": "https://github.com/aydansamedova/Camellia_baku",
    "homepage": null,
    "size": 49599,
    "stargazers_count": 2,
    "watchers_count": 2,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 2,
    "default_branch": "main"
  },
  {
    "id": 391185271,
    "node_id": "MDEwOlJlcG9zaXRvcnkzOTExODUyNzE=",
    "name": "codeSTACKr",
    "full_name": "aydansamedova/codeSTACKr",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/codeSTACKr",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/aydansamedova/codeSTACKr",
    "forks_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/codeSTACKr/deployments",
    "created_at": "2021-07-30T20:51:10Z",
    "updated_at": "2021-07-30T20:51:12Z",
    "pushed_at": "2021-07-30T14:07:14Z",
    "git_url": "git://github.com/aydansamedova/codeSTACKr.git",
    "ssh_url": "git@github.com:aydansamedova/codeSTACKr.git",
    "clone_url": "https://github.com/aydansamedova/codeSTACKr.git",
    "svn_url": "https://github.com/aydansamedova/codeSTACKr",
    "homepage": null,
    "size": 108,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 313599372,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMTM1OTkzNzI=",
    "name": "flask_crud",
    "full_name": "aydansamedova/flask_crud",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/flask_crud",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/flask_crud",
    "forks_url": "https://api.github.com/repos/aydansamedova/flask_crud/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/flask_crud/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/flask_crud/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/flask_crud/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/flask_crud/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/flask_crud/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/flask_crud/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/flask_crud/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/flask_crud/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/flask_crud/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/flask_crud/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/flask_crud/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/flask_crud/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/flask_crud/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/flask_crud/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/flask_crud/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/flask_crud/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/flask_crud/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/flask_crud/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/flask_crud/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/flask_crud/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/flask_crud/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/flask_crud/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/flask_crud/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/flask_crud/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/flask_crud/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/flask_crud/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/flask_crud/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/flask_crud/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/flask_crud/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/flask_crud/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/flask_crud/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/flask_crud/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/flask_crud/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/flask_crud/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/flask_crud/deployments",
    "created_at": "2020-11-17T11:33:54Z",
    "updated_at": "2020-11-17T11:37:32Z",
    "pushed_at": "2020-11-17T11:37:29Z",
    "git_url": "git://github.com/aydansamedova/flask_crud.git",
    "ssh_url": "git@github.com:aydansamedova/flask_crud.git",
    "clone_url": "https://github.com/aydansamedova/flask_crud.git",
    "svn_url": "https://github.com/aydansamedova/flask_crud",
    "homepage": null,
    "size": 3,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 309354532,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDkzNTQ1MzI=",
    "name": "formValidate",
    "full_name": "aydansamedova/formValidate",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/formValidate",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/formValidate",
    "forks_url": "https://api.github.com/repos/aydansamedova/formValidate/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/formValidate/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/formValidate/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/formValidate/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/formValidate/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/formValidate/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/formValidate/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/formValidate/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/formValidate/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/formValidate/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/formValidate/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/formValidate/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/formValidate/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/formValidate/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/formValidate/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/formValidate/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/formValidate/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/formValidate/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/formValidate/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/formValidate/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/formValidate/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/formValidate/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/formValidate/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/formValidate/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/formValidate/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/formValidate/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/formValidate/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/formValidate/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/formValidate/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/formValidate/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/formValidate/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/formValidate/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/formValidate/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/formValidate/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/formValidate/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/formValidate/deployments",
    "created_at": "2020-11-02T11:49:17Z",
    "updated_at": "2021-01-29T17:42:02Z",
    "pushed_at": "2020-11-06T12:46:25Z",
    "git_url": "git://github.com/aydansamedova/formValidate.git",
    "ssh_url": "git@github.com:aydansamedova/formValidate.git",
    "clone_url": "https://github.com/aydansamedova/formValidate.git",
    "svn_url": "https://github.com/aydansamedova/formValidate",
    "homepage": null,
    "size": 5,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 7,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 7,
    "open_issues": 1,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 320888448,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjA4ODg0NDg=",
    "name": "FrontendMentorChallanges_and_figma",
    "full_name": "aydansamedova/FrontendMentorChallanges_and_figma",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/FrontendMentorChallanges_and_figma",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma",
    "forks_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/FrontendMentorChallanges_and_figma/deployments",
    "created_at": "2020-12-12T17:41:51Z",
    "updated_at": "2021-08-23T15:14:07Z",
    "pushed_at": "2021-08-23T15:14:04Z",
    "git_url": "git://github.com/aydansamedova/FrontendMentorChallanges_and_figma.git",
    "ssh_url": "git@github.com:aydansamedova/FrontendMentorChallanges_and_figma.git",
    "clone_url": "https://github.com/aydansamedova/FrontendMentorChallanges_and_figma.git",
    "svn_url": "https://github.com/aydansamedova/FrontendMentorChallanges_and_figma",
    "homepage": null,
    "size": 75666,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "SCSS",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 403382224,
    "node_id": "MDEwOlJlcG9zaXRvcnk0MDMzODIyMjQ=",
    "name": "GalaxyPortfolio",
    "full_name": "aydansamedova/GalaxyPortfolio",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/GalaxyPortfolio",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio",
    "forks_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/GalaxyPortfolio/deployments",
    "created_at": "2021-09-05T18:19:17Z",
    "updated_at": "2021-09-06T17:23:28Z",
    "pushed_at": "2021-09-05T18:20:35Z",
    "git_url": "git://github.com/aydansamedova/GalaxyPortfolio.git",
    "ssh_url": "git@github.com:aydansamedova/GalaxyPortfolio.git",
    "clone_url": "https://github.com/aydansamedova/GalaxyPortfolio.git",
    "svn_url": "https://github.com/aydansamedova/GalaxyPortfolio",
    "homepage": null,
    "size": 257,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 464923176,
    "node_id": "R_kgDOG7YqKA",
    "name": "GithubUsers",
    "full_name": "aydansamedova/GithubUsers",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/GithubUsers",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/GithubUsers",
    "forks_url": "https://api.github.com/repos/aydansamedova/GithubUsers/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/GithubUsers/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/GithubUsers/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/GithubUsers/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/GithubUsers/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/GithubUsers/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/GithubUsers/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/GithubUsers/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/GithubUsers/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/GithubUsers/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/GithubUsers/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/GithubUsers/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/GithubUsers/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/GithubUsers/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/GithubUsers/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/GithubUsers/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/GithubUsers/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/GithubUsers/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/GithubUsers/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/GithubUsers/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/GithubUsers/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/GithubUsers/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/GithubUsers/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/GithubUsers/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/GithubUsers/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/GithubUsers/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/GithubUsers/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/GithubUsers/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/GithubUsers/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/GithubUsers/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/GithubUsers/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/GithubUsers/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/GithubUsers/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/GithubUsers/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/GithubUsers/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/GithubUsers/deployments",
    "created_at": "2022-03-01T14:19:46Z",
    "updated_at": "2022-03-01T17:45:49Z",
    "pushed_at": "2022-03-01T17:45:46Z",
    "git_url": "git://github.com/aydansamedova/GithubUsers.git",
    "ssh_url": "git@github.com:aydansamedova/GithubUsers.git",
    "clone_url": "https://github.com/aydansamedova/GithubUsers.git",
    "svn_url": "https://github.com/aydansamedova/GithubUsers",
    "homepage": null,
    "size": 320,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 403969028,
    "node_id": "MDEwOlJlcG9zaXRvcnk0MDM5NjkwMjg=",
    "name": "GlobusThree.js",
    "full_name": "aydansamedova/GlobusThree.js",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/GlobusThree.js",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/GlobusThree.js",
    "forks_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/GlobusThree.js/deployments",
    "created_at": "2021-09-07T12:25:15Z",
    "updated_at": "2021-09-07T12:26:42Z",
    "pushed_at": "2021-09-07T12:26:39Z",
    "git_url": "git://github.com/aydansamedova/GlobusThree.js.git",
    "ssh_url": "git@github.com:aydansamedova/GlobusThree.js.git",
    "clone_url": "https://github.com/aydansamedova/GlobusThree.js.git",
    "svn_url": "https://github.com/aydansamedova/GlobusThree.js",
    "homepage": null,
    "size": 809,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 293548414,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTM1NDg0MTQ=",
    "name": "Hackerrank-python",
    "full_name": "aydansamedova/Hackerrank-python",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/Hackerrank-python",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/Hackerrank-python",
    "forks_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/Hackerrank-python/deployments",
    "created_at": "2020-09-07T14:19:03Z",
    "updated_at": "2020-09-12T15:04:59Z",
    "pushed_at": "2020-09-12T15:04:57Z",
    "git_url": "git://github.com/aydansamedova/Hackerrank-python.git",
    "ssh_url": "git@github.com:aydansamedova/Hackerrank-python.git",
    "clone_url": "https://github.com/aydansamedova/Hackerrank-python.git",
    "svn_url": "https://github.com/aydansamedova/Hackerrank-python",
    "homepage": null,
    "size": 2,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 327983253,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjc5ODMyNTM=",
    "name": "javascriptMiniProjects",
    "full_name": "aydansamedova/javascriptMiniProjects",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/javascriptMiniProjects",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects",
    "forks_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/javascriptMiniProjects/deployments",
    "created_at": "2021-01-08T18:34:57Z",
    "updated_at": "2021-07-24T10:43:14Z",
    "pushed_at": "2021-07-22T16:15:24Z",
    "git_url": "git://github.com/aydansamedova/javascriptMiniProjects.git",
    "ssh_url": "git@github.com:aydansamedova/javascriptMiniProjects.git",
    "clone_url": "https://github.com/aydansamedova/javascriptMiniProjects.git",
    "svn_url": "https://github.com/aydansamedova/javascriptMiniProjects",
    "homepage": null,
    "size": 17529,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "CSS",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 328120259,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMjgxMjAyNTk=",
    "name": "javascript_algoritm",
    "full_name": "aydansamedova/javascript_algoritm",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/javascript_algoritm",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/javascript_algoritm",
    "forks_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/javascript_algoritm/deployments",
    "created_at": "2021-01-09T09:35:31Z",
    "updated_at": "2021-06-17T14:19:23Z",
    "pushed_at": "2021-06-17T14:19:19Z",
    "git_url": "git://github.com/aydansamedova/javascript_algoritm.git",
    "ssh_url": "git@github.com:aydansamedova/javascript_algoritm.git",
    "clone_url": "https://github.com/aydansamedova/javascript_algoritm.git",
    "svn_url": "https://github.com/aydansamedova/javascript_algoritm",
    "homepage": null,
    "size": 17,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 391085350,
    "node_id": "MDEwOlJlcG9zaXRvcnkzOTEwODUzNTA=",
    "name": "Javascript_games",
    "full_name": "aydansamedova/Javascript_games",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/Javascript_games",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/Javascript_games",
    "forks_url": "https://api.github.com/repos/aydansamedova/Javascript_games/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/Javascript_games/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/Javascript_games/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/Javascript_games/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/Javascript_games/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/Javascript_games/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/Javascript_games/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/Javascript_games/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/Javascript_games/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/Javascript_games/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/Javascript_games/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/Javascript_games/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/Javascript_games/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/Javascript_games/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/Javascript_games/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/Javascript_games/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/Javascript_games/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/Javascript_games/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/Javascript_games/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/Javascript_games/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/Javascript_games/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/Javascript_games/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/Javascript_games/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/Javascript_games/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/Javascript_games/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/Javascript_games/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/Javascript_games/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/Javascript_games/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/Javascript_games/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/Javascript_games/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/Javascript_games/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/Javascript_games/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/Javascript_games/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/Javascript_games/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/Javascript_games/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/Javascript_games/deployments",
    "created_at": "2021-07-30T14:04:42Z",
    "updated_at": "2021-08-03T12:42:36Z",
    "pushed_at": "2021-08-01T11:07:59Z",
    "git_url": "git://github.com/aydansamedova/Javascript_games.git",
    "ssh_url": "git@github.com:aydansamedova/Javascript_games.git",
    "clone_url": "https://github.com/aydansamedova/Javascript_games.git",
    "svn_url": "https://github.com/aydansamedova/Javascript_games",
    "homepage": null,
    "size": 4622,
    "stargazers_count": 2,
    "watchers_count": 2,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 1,
    "watchers": 2,
    "default_branch": "main"
  },
  {
    "id": 330656479,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMzA2NTY0Nzk=",
    "name": "jsChallenges1Hour",
    "full_name": "aydansamedova/jsChallenges1Hour",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/jsChallenges1Hour",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour",
    "forks_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/jsChallenges1Hour/deployments",
    "created_at": "2021-01-18T12:17:26Z",
    "updated_at": "2021-07-31T15:12:03Z",
    "pushed_at": "2021-01-18T12:19:09Z",
    "git_url": "git://github.com/aydansamedova/jsChallenges1Hour.git",
    "ssh_url": "git@github.com:aydansamedova/jsChallenges1Hour.git",
    "clone_url": "https://github.com/aydansamedova/jsChallenges1Hour.git",
    "svn_url": "https://github.com/aydansamedova/jsChallenges1Hour",
    "homepage": null,
    "size": 1326,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "main"
  },
  {
    "id": 417826222,
    "node_id": "R_kgDOGOeFrg",
    "name": "LuciaBujiteri",
    "full_name": "aydansamedova/LuciaBujiteri",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/LuciaBujiteri",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri",
    "forks_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/LuciaBujiteri/deployments",
    "created_at": "2021-10-16T12:47:36Z",
    "updated_at": "2021-12-27T07:24:55Z",
    "pushed_at": "2021-10-25T09:06:54Z",
    "git_url": "git://github.com/aydansamedova/LuciaBujiteri.git",
    "ssh_url": "git@github.com:aydansamedova/LuciaBujiteri.git",
    "clone_url": "https://github.com/aydansamedova/LuciaBujiteri.git",
    "svn_url": "https://github.com/aydansamedova/LuciaBujiteri",
    "homepage": null,
    "size": 6103,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 1,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 421415598,
    "node_id": "R_kgDOGR5Krg",
    "name": "MyPortfolio",
    "full_name": "aydansamedova/MyPortfolio",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/MyPortfolio",
    "description": "Config files for my GitHub profile.",
    "fork": true,
    "url": "https://api.github.com/repos/aydansamedova/MyPortfolio",
    "forks_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/MyPortfolio/deployments",
    "created_at": "2021-10-26T12:28:33Z",
    "updated_at": "2021-10-26T12:28:34Z",
    "pushed_at": "2021-10-12T22:38:35Z",
    "git_url": "git://github.com/aydansamedova/MyPortfolio.git",
    "ssh_url": "git@github.com:aydansamedova/MyPortfolio.git",
    "clone_url": "https://github.com/aydansamedova/MyPortfolio.git",
    "svn_url": "https://github.com/aydansamedova/MyPortfolio",
    "homepage": "https://github.com/yusifiz",
    "size": 44516,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 393743529,
    "node_id": "MDEwOlJlcG9zaXRvcnkzOTM3NDM1Mjk=",
    "name": "React-Projects",
    "full_name": "aydansamedova/React-Projects",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/React-Projects",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/React-Projects",
    "forks_url": "https://api.github.com/repos/aydansamedova/React-Projects/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/React-Projects/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/React-Projects/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/React-Projects/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/React-Projects/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/React-Projects/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/React-Projects/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/React-Projects/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/React-Projects/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/React-Projects/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/React-Projects/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/React-Projects/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/React-Projects/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/React-Projects/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/React-Projects/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/React-Projects/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/React-Projects/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/React-Projects/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/React-Projects/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/React-Projects/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/React-Projects/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/React-Projects/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/React-Projects/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/React-Projects/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/React-Projects/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/React-Projects/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/React-Projects/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/React-Projects/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/React-Projects/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/React-Projects/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/React-Projects/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/React-Projects/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/React-Projects/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/React-Projects/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/React-Projects/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/React-Projects/deployments",
    "created_at": "2021-08-07T17:05:05Z",
    "updated_at": "2022-01-03T15:39:34Z",
    "pushed_at": "2022-02-28T08:26:35Z",
    "git_url": "git://github.com/aydansamedova/React-Projects.git",
    "ssh_url": "git@github.com:aydansamedova/React-Projects.git",
    "clone_url": "https://github.com/aydansamedova/React-Projects.git",
    "svn_url": "https://github.com/aydansamedova/React-Projects",
    "homepage": null,
    "size": 71697,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 312014886,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMTIwMTQ4ODY=",
    "name": "snake_game",
    "full_name": "aydansamedova/snake_game",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/snake_game",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/snake_game",
    "forks_url": "https://api.github.com/repos/aydansamedova/snake_game/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/snake_game/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/snake_game/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/snake_game/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/snake_game/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/snake_game/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/snake_game/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/snake_game/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/snake_game/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/snake_game/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/snake_game/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/snake_game/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/snake_game/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/snake_game/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/snake_game/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/snake_game/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/snake_game/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/snake_game/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/snake_game/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/snake_game/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/snake_game/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/snake_game/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/snake_game/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/snake_game/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/snake_game/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/snake_game/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/snake_game/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/snake_game/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/snake_game/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/snake_game/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/snake_game/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/snake_game/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/snake_game/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/snake_game/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/snake_game/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/snake_game/deployments",
    "created_at": "2020-11-11T15:42:55Z",
    "updated_at": "2020-11-11T17:26:50Z",
    "pushed_at": "2020-11-11T17:26:47Z",
    "git_url": "git://github.com/aydansamedova/snake_game.git",
    "ssh_url": "git@github.com:aydansamedova/snake_game.git",
    "clone_url": "https://github.com/aydansamedova/snake_game.git",
    "svn_url": "https://github.com/aydansamedova/snake_game",
    "homepage": null,
    "size": 2,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 1,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 293537136,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTM1MzcxMzY=",
    "name": "StudentManagement",
    "full_name": "aydansamedova/StudentManagement",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/StudentManagement",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/StudentManagement",
    "forks_url": "https://api.github.com/repos/aydansamedova/StudentManagement/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/StudentManagement/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/StudentManagement/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/StudentManagement/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/StudentManagement/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/StudentManagement/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/StudentManagement/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/StudentManagement/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/StudentManagement/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/StudentManagement/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/StudentManagement/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/StudentManagement/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/StudentManagement/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/StudentManagement/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/StudentManagement/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/StudentManagement/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/StudentManagement/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/StudentManagement/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/StudentManagement/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/StudentManagement/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/StudentManagement/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/StudentManagement/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/StudentManagement/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/StudentManagement/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/StudentManagement/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/StudentManagement/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/StudentManagement/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/StudentManagement/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/StudentManagement/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/StudentManagement/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/StudentManagement/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/StudentManagement/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/StudentManagement/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/StudentManagement/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/StudentManagement/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/StudentManagement/deployments",
    "created_at": "2020-09-07T13:33:25Z",
    "updated_at": "2020-09-07T13:42:39Z",
    "pushed_at": "2020-09-07T13:42:37Z",
    "git_url": "git://github.com/aydansamedova/StudentManagement.git",
    "ssh_url": "git@github.com:aydansamedova/StudentManagement.git",
    "clone_url": "https://github.com/aydansamedova/StudentManagement.git",
    "svn_url": "https://github.com/aydansamedova/StudentManagement",
    "homepage": null,
    "size": 2,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 330461326,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMzA0NjEzMjY=",
    "name": "utilitis",
    "full_name": "aydansamedova/utilitis",
    "private": false,
    "owner": {
      "login": "aydansamedova",
      "id": 68549196,
      "node_id": "MDQ6VXNlcjY4NTQ5MTk2",
      "avatar_url": "https://avatars.githubusercontent.com/u/68549196?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/aydansamedova",
      "html_url": "https://github.com/aydansamedova",
      "followers_url": "https://api.github.com/users/aydansamedova/followers",
      "following_url": "https://api.github.com/users/aydansamedova/following{/other_user}",
      "gists_url": "https://api.github.com/users/aydansamedova/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/aydansamedova/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/aydansamedova/subscriptions",
      "organizations_url": "https://api.github.com/users/aydansamedova/orgs",
      "repos_url": "https://api.github.com/users/aydansamedova/repos",
      "events_url": "https://api.github.com/users/aydansamedova/events{/privacy}",
      "received_events_url": "https://api.github.com/users/aydansamedova/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/aydansamedova/utilitis",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/aydansamedova/utilitis",
    "forks_url": "https://api.github.com/repos/aydansamedova/utilitis/forks",
    "keys_url": "https://api.github.com/repos/aydansamedova/utilitis/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/aydansamedova/utilitis/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/aydansamedova/utilitis/teams",
    "hooks_url": "https://api.github.com/repos/aydansamedova/utilitis/hooks",
    "issue_events_url": "https://api.github.com/repos/aydansamedova/utilitis/issues/events{/number}",
    "events_url": "https://api.github.com/repos/aydansamedova/utilitis/events",
    "assignees_url": "https://api.github.com/repos/aydansamedova/utilitis/assignees{/user}",
    "branches_url": "https://api.github.com/repos/aydansamedova/utilitis/branches{/branch}",
    "tags_url": "https://api.github.com/repos/aydansamedova/utilitis/tags",
    "blobs_url": "https://api.github.com/repos/aydansamedova/utilitis/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/aydansamedova/utilitis/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/aydansamedova/utilitis/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/aydansamedova/utilitis/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/aydansamedova/utilitis/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/aydansamedova/utilitis/languages",
    "stargazers_url": "https://api.github.com/repos/aydansamedova/utilitis/stargazers",
    "contributors_url": "https://api.github.com/repos/aydansamedova/utilitis/contributors",
    "subscribers_url": "https://api.github.com/repos/aydansamedova/utilitis/subscribers",
    "subscription_url": "https://api.github.com/repos/aydansamedova/utilitis/subscription",
    "commits_url": "https://api.github.com/repos/aydansamedova/utilitis/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/aydansamedova/utilitis/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/aydansamedova/utilitis/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/aydansamedova/utilitis/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/aydansamedova/utilitis/contents/{+path}",
    "compare_url": "https://api.github.com/repos/aydansamedova/utilitis/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/aydansamedova/utilitis/merges",
    "archive_url": "https://api.github.com/repos/aydansamedova/utilitis/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/aydansamedova/utilitis/downloads",
    "issues_url": "https://api.github.com/repos/aydansamedova/utilitis/issues{/number}",
    "pulls_url": "https://api.github.com/repos/aydansamedova/utilitis/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/aydansamedova/utilitis/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/aydansamedova/utilitis/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/aydansamedova/utilitis/labels{/name}",
    "releases_url": "https://api.github.com/repos/aydansamedova/utilitis/releases{/id}",
    "deployments_url": "https://api.github.com/repos/aydansamedova/utilitis/deployments",
    "created_at": "2021-01-17T18:41:46Z",
    "updated_at": "2021-01-17T19:44:49Z",
    "pushed_at": "2021-01-17T19:44:47Z",
    "git_url": "git://github.com/aydansamedova/utilitis.git",
    "ssh_url": "git@github.com:aydansamedova/utilitis.git",
    "clone_url": "https://github.com/aydansamedova/utilitis.git",
    "svn_url": "https://github.com/aydansamedova/utilitis",
    "homepage": null,
    "size": 2,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "topics": [
      
    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  }
]